import map from './parser-map';
import helpers from '../helpers';

const categoryMap = map.category;

class Category {
  constructor(raswCategory) {
    this.id = raswCategory[categoryMap.id];
    this.idSport = raswCategory[categoryMap.idSport];
    this.name = raswCategory[categoryMap.name];
    this.shortName = raswCategory[categoryMap.shortName] || this.name;
    this.isoId = raswCategory[categoryMap.isoId];
    this.isoName = raswCategory[categoryMap.isoName];
    this.position = parseInt(raswCategory[categoryMap.position], 10) || helpers.maxInt;
    this.numberOfMatches = parseInt(raswCategory[categoryMap.numberOfMatches], 10);
    this.providerId = raswCategory[categoryMap.providerId];
    this.active = true;
  }
}

export default Category;
